import { Injectable, InjectionToken, inject } from '@angular/core';
import { Observable, catchError, combineLatest, map, of } from 'rxjs';

import { ImpersonableUser } from '@mobi/rwc-utils-azure-ng-jslib';
import { ConfigurationService } from '@mobi/rwc-utils-common-ng-jslib';

import { CipTestUsersService } from './cip-test-users.service';

/**
 * Optional token to provide additional impersonable users that will be merged with test users.
 */
export const CUSTOM_IMPERSONABLE_USERS = new InjectionToken<Observable<ImpersonableUser[]>>(
    'Provide additional impersonable users that will be merged with test users in preprod.',
    { factory: () => of([]) }
);

@Injectable({ providedIn: 'root' })
export class ImpersonableUsersService {
    #configurationService = inject(ConfigurationService);
    #customImpersonableUsers$ = inject(CUSTOM_IMPERSONABLE_USERS).pipe(catchError(() => of([])));
    #testUsers$ = inject(CipTestUsersService).testUsers$;

    readonly impersonableUsers$: Observable<ImpersonableUser[]> = this.#getImpersonableUsers();

    #getImpersonableUsers(): Observable<ImpersonableUser[]> {
        if (this.#configurationService.isProduction()) {
            return this.#customImpersonableUsers$;
        }
        return combineLatest([this.#testUsers$, this.#customImpersonableUsers$]).pipe(
            map(([test, additional]) => [...additional, ...test])
        );
    }
}
